"use client";
import React from "react";
import {Button, Stack, Text} from "@chakra-ui/react";
import {Balancer} from "react-wrap-balancer";
import {useTextVariants} from "@/theme/components/useSectionHeading";
import {BUTTON_VARIANTS} from "@/theme/components/button";
import {scrollToElement} from "@/utils/scrollToElement";

export type TableFooterProps = {
  btnText?: string;
  text1?: string | React.ReactNode;
};

const PricingFooter = (props: TableFooterProps) => {
  const TextVariant = useTextVariants();
  const {text1, btnText} = props;
  return (
    <Stack mt={6} spacing={6}>
      {text1 && (
        <Text
          variant={TextVariant}
          color="text.100"
          fontStyle={"italic"}
          textAlign={"center"}
        >
          <Balancer>{text1}</Balancer>
        </Text>
      )}
      {btnText && (
        <Button
          variant={BUTTON_VARIANTS.IDEAL}
          onClick={() => scrollToElement("contact-us", 120)}
          alignSelf={"center"}
          justifySelf={"center"}
          px={6}
        >
          {btnText}
        </Button>
      )}
    </Stack>
  );
};

export default PricingFooter;
